export default __webpack_public_path__ + "static/media/world-map-faint-v1.5315436c.png";